import { Link } from 'react-router';

const NotFound = () => {
    return (
        <section>
            <h2>Page not found</h2>
            <p>
                <Link to="/">Back to home</Link>
            </p>
        </section>
    );
};

export default NotFound;
